import { AxiosResponse } from "axios";
import { AxiosHelper } from "../axiosConfig";
import { IPassageSpeech } from "../model/shared/passageSpeech";
import APIConstant from "../utils/apiConstant";

export function getSpeechFromText(text: string, language: string) {
  return AxiosHelper.axiosInstance().post(
    APIConstant.TTS_API.GetAudioFromText,
    {
      text,
      lang: language,
    },
    {
      responseType: "arraybuffer",
    }
  );
}

export function createPassageSpeech(
  subjectId: number,
  passages: Array<IPassageSpeech>
): Promise<AxiosResponse<boolean>> {
  return AxiosHelper.axiosInstance().post(
    APIConstant.TTS_API.CreatePassageSpeech,
    {
      subjectId,
      passages,
    }
  );
}
